<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title parametre-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                        <g filter="url(#filter0_d_1938_1605)">
                            <path
                                d="M23.7844 8.77288C23.7311 8.08623 23.1655 7.54858 22.4809 7.52592C21.5601 7.49571 20.6795 6.9972 20.1992 6.13546C19.7128 5.27165 19.7422 4.25541 20.1904 3.44653C20.5299 2.83335 20.3345 2.06637 19.7641 1.66056C19.318 1.34332 18.8432 1.06386 18.3445 0.826275C17.7105 0.524149 16.9468 0.730144 16.5813 1.33165C16.1017 2.12061 15.2382 2.64727 14.2483 2.64727C13.2585 2.64727 12.3956 2.12061 11.9154 1.33165C11.5492 0.729457 10.7861 0.523462 10.1522 0.826275C9.65349 1.06386 9.17939 1.34332 8.73261 1.66056C8.16218 2.06637 7.9668 2.83267 8.30632 3.44653C8.75447 4.25609 8.78384 5.27234 8.29744 6.13546C7.81719 6.9972 6.93661 7.49502 6.01573 7.52592C5.33122 7.54858 4.76557 8.08623 4.71229 8.77288C4.69316 9.01733 4.68359 9.26452 4.68359 9.51378C4.68359 9.76303 4.69316 10.0102 4.71229 10.2547C4.76557 10.9413 5.33122 11.479 6.01573 11.5016C6.93661 11.5318 7.81719 12.0297 8.29744 12.8921C8.78384 13.7559 8.75447 14.7721 8.30632 15.581C7.9668 16.1942 8.16218 16.9612 8.73261 17.367C9.1787 17.6842 9.65349 17.9637 10.1522 18.2013C10.7861 18.5034 11.5492 18.2974 11.9154 17.6959C12.395 16.9069 13.2585 16.3803 14.2483 16.3803C15.2382 16.3803 16.101 16.9063 16.5813 17.6959C16.9475 18.2981 17.7105 18.5041 18.3445 18.2013C18.8432 17.9637 19.318 17.6842 19.7641 17.367C20.3345 16.9612 20.5299 16.1949 20.1904 15.581C19.7422 14.7715 19.7128 13.7552 20.1992 12.8921C20.6795 12.0304 21.5601 11.5325 22.4809 11.5016C23.1655 11.479 23.7311 10.9413 23.7844 10.2547C23.8035 10.0102 23.8131 9.76303 23.8131 9.51378C23.8131 9.26452 23.8035 9.01733 23.7844 8.77288ZM14.249 12.947C12.3629 12.947 10.8333 11.4096 10.8333 9.51378C10.8333 7.61793 12.3629 6.08052 14.249 6.08052C16.1352 6.08052 17.6648 7.61793 17.6648 9.51378C17.6648 11.4096 16.1352 12.947 14.249 12.947Z"
                                fill="#265D91" />
                            <path
                                d="M10.7591 19.0264C10.4571 19.0264 10.1497 18.9598 9.85935 18.8218C9.32991 18.5691 8.81824 18.2684 8.33798 17.9271C7.47312 17.3126 7.20328 16.161 7.70881 15.2471C8.05994 14.614 8.05721 13.8594 7.70266 13.2297C7.35152 12.6001 6.71346 12.2114 5.99342 12.1874C4.95436 12.1531 4.11135 11.3449 4.03074 10.308C4.01093 10.045 4 9.78 4 9.51289C4 9.24578 4.01093 8.98142 4.03074 8.71912C4.11135 7.68091 4.95504 6.87341 5.99274 6.83839C6.71346 6.81504 7.35152 6.4264 7.70129 5.7988C8.05721 5.16639 8.05926 4.41245 7.70881 3.77936C7.20328 2.86543 7.47312 1.71323 8.33798 1.09936C8.81755 0.758097 9.32923 0.457344 9.85867 0.205343C10.8192 -0.251966 11.9539 0.0776265 12.4977 0.973705C12.8734 1.59169 13.5272 1.96042 14.2479 1.96042C14.9686 1.96042 15.6224 1.59169 15.9981 0.973019C16.5426 0.0776265 17.6793 -0.251966 18.6364 0.204657C19.1659 0.457344 19.6775 0.758097 20.1578 1.09936C21.0227 1.71391 21.2925 2.86543 20.787 3.77936C20.4358 4.41245 20.4386 5.16708 20.7931 5.79674C21.1443 6.4264 21.7823 6.81504 22.5024 6.83907C23.5414 6.87341 24.3844 7.68159 24.465 8.71844C24.4848 8.98142 24.4958 9.24647 24.4958 9.51358C24.4958 9.78069 24.4848 10.045 24.465 10.3073C24.3844 11.3456 23.5407 12.1531 22.503 12.1881C21.7823 12.2114 21.1443 12.6001 20.7945 13.2277C20.4386 13.8601 20.4365 14.614 20.787 15.2471C21.2925 16.161 21.0227 17.3132 20.1578 17.9271C19.6782 18.2684 19.1665 18.5691 18.6371 18.8211C17.6746 19.2791 16.5419 18.9482 15.9974 18.0534C15.6224 17.4348 14.9686 17.066 14.2479 17.066C13.5272 17.066 12.8734 17.4348 12.4984 18.0528C12.1185 18.6762 11.4531 19.0264 10.7591 19.0264ZM10.7591 1.37402C10.6539 1.37402 10.5459 1.39737 10.4434 1.44612C9.98574 1.66448 9.54237 1.9254 9.12634 2.22066C8.83258 2.4294 8.73694 2.81256 8.90295 3.11194C9.48704 4.16663 9.48294 5.4232 8.89133 6.47378C8.31612 7.50581 7.22241 8.17324 6.03714 8.21169C5.70172 8.22268 5.4189 8.49253 5.39294 8.82624C5.37586 9.05284 5.36629 9.28218 5.36629 9.51358C5.36629 9.74498 5.37586 9.97501 5.39294 10.2023C5.4189 10.5346 5.70172 10.8045 6.03783 10.8155C7.22172 10.8546 8.31612 11.5213 8.8927 12.5561C9.48226 13.6033 9.48704 14.8598 8.90295 15.9152C8.73694 16.2146 8.83258 16.5978 9.12634 16.8065C9.54169 17.1018 9.98573 17.3627 10.4441 17.581C10.7714 17.7376 11.1539 17.6318 11.3322 17.3373C11.9573 16.308 13.0469 15.6934 14.2479 15.6934C15.4489 15.6934 16.5385 16.3087 17.1636 17.338C17.3425 17.6325 17.7237 17.7362 18.0523 17.581C18.51 17.3627 18.9534 17.1018 19.3694 16.8065C19.6632 16.5978 19.7588 16.2146 19.5928 15.9152C19.0087 14.8605 19.0128 13.604 19.6044 12.5534C20.1797 11.5213 21.2734 10.8539 22.4586 10.8155C22.7941 10.8045 23.0769 10.5346 23.1028 10.2009C23.1199 9.97432 23.1295 9.74498 23.1295 9.51358C23.1295 9.28218 23.1199 9.05215 23.1028 8.82487C23.0769 8.49253 22.7941 8.22268 22.458 8.21169C21.2741 8.17255 20.1797 7.50581 19.6031 6.47103C19.0135 5.42389 19.0087 4.16732 19.5928 3.11194C19.7588 2.81256 19.6632 2.4294 19.3694 2.22066C18.9541 1.9254 18.51 1.66448 18.0517 1.44612C17.7244 1.29025 17.3425 1.39531 17.1642 1.6892C16.5385 2.71917 15.4482 3.33372 14.2479 3.33372C13.0476 3.33372 11.9573 2.71917 11.3315 1.6892C11.2086 1.48663 10.99 1.37402 10.7591 1.37402Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_1938_1605" x="0" y="0" width="28.4961" height="27.0264"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1938_1605" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1938_1605"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>
                    Paramètres
                </h1>
                <!--begin::Menu-->
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a  class="text-muted"  routerLink="/">Accueil</a>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Paramètres</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Évaluation</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Avis société</li>

                <!--end::Item-->
                <!--begin::Item-->

                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="mb-5 pb-8">
        <div class="container-fluid">
            <div class="title">
                <h4>Avis société </h4>
            </div>


        </div>
        <!-- <div class="container-fluid">
            <div class="card-body pt-5">
              
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active card" id="kt_tab_pane_1" role="tabpanel">
                         <div class="container pt-15 pb-10">
                            <div class="table-responsive">
                                <table class="table align-middle   fs-6 gy-5 mb-4" id="kt_customers_table">
                                    <thead>
                                        <tr class="text-start gs-0 ">
                                            <th class="min-w-200px td-bg p-10"><span>Nom société</span></th>
                                            <th class="min-w-200px tdbg p-10"><span>Évaluation</span></th>
                                            <th class="min-w-200px td-bg2 p-10"><span>Liste des évaluations</span></th>
                                        </tr>
                                    </thead>
                                    <tbody class="fw-semibold text-gray-600">
                                      <tr *ngFor="let data of listCompanies">
                                        <td>
                                            <div class="societe">
                                                <img *ngIf="data?.company?.logo&&data?.company?.logo!='avatar.png'&&data?.company?.logo!='undefined'" class="table-img" src="{{url+ data?.company?.logo}}" alt="" width="75px">
                                                <img *ngIf="!data?.company?.logo||data?.company?.logo&&(data?.company?.logo=='avatar.png'||data?.company?.logo=='undefined')" class="table-img" src="/assets/media/logos/logo-avatar.jpg" alt="" width="75px">
                                                <span>{{data?.company?.name?data?.company?.name:'---'}}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="stars">
                                                <rating [(ngModel)]="data.average_note" 
                                                [titles]="[' ',' ',' ',' ',' ']"
                                                [max]="5" 
                                                [readonly]="true" 
                                                ></rating>
                                            </div>
                                                
                                        </td>
                                        <td>
                                            <a  (click)="showEvaluateCompany(data.company.id,data.company.type)" class="liste cursor-pointer" >Liste des évaluations</a>
                                        </td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="alert alert-warning" role="alert"
                             *ngIf="listCompanies&&!listCompanies.length ">
                             <span class="empty-list">
                               La liste est vide
                             </span>
                           </div>
                               <div class="pagination" *ngIf="listCompanies && listCompanies.length">
                                   <app-pagination [data]="listCompanies" [lengthData]="totalItems" (setPages)="getItems($event)" > </app-pagination>
                                   </div>
                         </div>
                        </div>
                    </div>
            </div>
        </div> -->
        <div class="container-fluid mt-15">
            <div class="card-body pt-5">
               
                <div class="card pb-15 pb-10">
                    <div class="tab-content" id="kt_tab_pane_1">
                        <div class="tab-pane fade active show" id="kt_tab_pane_1" role="tabpanel">
                            <div class="add pt-10 pb-15">
                                <a class="cursor-pointer" (click)="openModal(add_update_question,'create')">+ Ajouter une
                                    évaluation</a>
                            </div>
                            <div class="container reviews">
                                <div class="review mb-5"  *ngFor="let item of listQuestion">
                                  <div class="row">
                                    <div class="col-lg-8 col-6 col-sm-8" style="margin: auto;">
                                        <div class="comment mb-3">
                                            <span>
                                                {{item.question}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-6 col-sm-4" style="margin: auto;">
                                        <div class="actions mb-3">
                                           <div class="edit-icon">
                                          <button type="button"  (click)="openModal(add_update_question,'update',item)" id="edit">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M0 18.5315V6.6184C0 5.91628 0.280618 5.24291 0.780122 4.74644C1.27963 4.24996 1.9571 3.97104 2.6635 3.97104H10.8072L8.18694 6.6184H2.6635V18.5315H14.6493V13.0449L17.3128 10.4405V18.5315C17.3128 19.2337 17.0322 19.907 16.5326 20.4035C16.0331 20.9 15.3557 21.1789 14.6493 21.1789H2.6635C1.9571 21.1789 1.27963 20.9 0.780122 20.4035C0.280618 19.907 0 19.2337 0 18.5315ZM19.3104 0C18.7808 0.000463426 18.273 0.209956 17.8987 0.58242L8.43332 10.1427C8.14205 10.437 7.92227 10.7935 7.79075 11.1851L6.83189 14.0476C6.81991 14.0933 6.82018 14.1414 6.83266 14.1871C6.84514 14.2327 6.86941 14.2743 6.90306 14.3077C6.93671 14.3412 6.97856 14.3653 7.02448 14.3777C7.07039 14.3901 7.11877 14.3904 7.16482 14.3785L10.0547 13.4354C10.4487 13.3047 10.8075 13.0863 11.1035 12.7967L20.7221 3.38862C21.0011 3.11095 21.191 2.75732 21.268 2.3724C21.3449 1.98747 21.3054 1.58852 21.1543 1.22593C21.0033 0.86334 20.7475 0.553372 20.4193 0.335176C20.0911 0.116981 19.7052 0.000345183 19.3104 0Z"
                                                    fill="#265D91" />
                                            </svg>
                                          </button>
                                           </div>
                                            <div class="delete-icon">
                                              <button type="button" (click)="openDeleteAlert(item)" id="delete">
                                                <svg data-bs-toggle="modal" 
                                                data-bs-target="#add_FAQ" width="17" height="19" viewBox="0 0 17 19"
                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M14.9851 4.17508H15.6809C15.8655 4.17508 16.0425 4.10177 16.173 3.97127C16.3035 3.84078 16.3768 3.66379 16.3768 3.47924C16.3768 3.29469 16.3035 3.11769 16.173 2.9872C16.0425 2.8567 15.8655 2.78339 15.6809 2.78339H12.2017V2.08754C12.2 1.5344 11.9796 1.00438 11.5884 0.613252C11.1973 0.222119 10.6673 0.001652 10.1141 0H5.93906C5.38591 0.001652 4.8559 0.222119 4.46477 0.613252C4.07363 1.00438 3.85317 1.5344 3.85151 2.08754V2.78339H0.695847C0.511297 2.78339 0.334305 2.8567 0.203809 2.9872C0.0733121 3.11769 0 3.29469 0 3.47924C0 3.66379 0.0733121 3.84078 0.203809 3.97127C0.334305 4.10177 0.511297 4.17508 0.695847 4.17508H1.06813V14.6128C1.06813 15.5355 1.43469 16.4205 2.08717 17.073C2.73965 17.7255 3.62461 18.092 4.54736 18.092H11.5058C12.4286 18.092 13.3135 17.7255 13.966 17.073C14.6185 16.4205 14.9851 15.5355 14.9851 14.6128V4.17508ZM6.6349 13.2211C6.6349 13.4056 6.56159 13.5826 6.43109 13.7131C6.3006 13.8436 6.12361 13.9169 5.93906 13.9169C5.75451 13.9169 5.57751 13.8436 5.44702 13.7131C5.31652 13.5826 5.24321 13.4056 5.24321 13.2211V7.65432C5.24321 7.46977 5.31652 7.29278 5.44702 7.16228C5.57751 7.03178 5.75451 6.95847 5.93906 6.95847C6.12361 6.95847 6.3006 7.03178 6.43109 7.16228C6.56159 7.29278 6.6349 7.46977 6.6349 7.65432V13.2211ZM10.81 13.2211C10.81 13.4056 10.7367 13.5826 10.6062 13.7131C10.4757 13.8436 10.2987 13.9169 10.1141 13.9169C9.92959 13.9169 9.7526 13.8436 9.6221 13.7131C9.4916 13.5826 9.41829 13.4056 9.41829 13.2211V7.65432C9.41829 7.46977 9.4916 7.29278 9.6221 7.16228C9.7526 7.03178 9.92959 6.95847 10.1141 6.95847C10.2987 6.95847 10.4757 7.03178 10.6062 7.16228C10.7367 7.29278 10.81 7.46977 10.81 7.65432V13.2211ZM10.81 2.78339H5.24321V2.08754C5.24321 1.90299 5.31652 1.726 5.44702 1.5955C5.57751 1.46501 5.75451 1.39169 5.93906 1.39169H10.1141C10.2987 1.39169 10.4757 1.46501 10.6062 1.5955C10.7367 1.726 10.81 1.90299 10.81 2.08754V2.78339Z"
                                                    fill="#EE6352" />
                                            </svg>
                                              </button>
    
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-lg-2 col-6 col-sm-4" style="margin: auto;">
                                        <div class="stars mb-3">
                                            <rating [titles]="[' ',' ',' ',' ',' ']" [readonly]="true"
                                                class="rating-stars"></rating>
                                        </div>
                                    </div> -->
                                  
                                  </div>
                                  
                                  

                                   
                                 
                                </div>
                            </div>
                         
                        </div>
                       
                      
                    </div>
                    </div>
                    </div>


                    
                </div>
    </div>
</div>
<div class="modal fade" id="add-eval" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
        <!--begin::Modal content-->
        <div class="modal-content">
            <!--begin::Modal header-->
            <div class="modal-header">
                <!--begin::Modal title-->
                <h2 class="">Ajouter évaluation</h2>
                <!--end::Modal title-->
                <!--begin::Close-->
                <div id="kt_customers_export_close" data-bs-dismiss="modal"
                    class="btn btn-icon btn-sm btn-active-icon-primary">
                    <i class="ki-duotone ki-cross fs-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
            </div>
            <div class="modal-body">
                <!--begin::Form-->
                <form id="kt_customers_export_form" class="form tools" action="#">
                    <!--begin::Input group-->
                    <!--begin::Label-->
                    <div class="mb-5">
                        <label for="question" class="form-label">Question</label>
                        <input type="text" class="form-control" placeholder="Question" />
                    </div>
                </form>
                <div class="text-end ">
                    <button type="reset" id="kt_customers_export_cancel" data-bs-dismiss="modal"
                        class="footer-btn annuler me-3">Annuler</button>
                    <button type="submit" id="kt_customers_export_submit" class="footer-btn confirmer ">
                        <span class="indicator-label">Confirmer</span>
                        <span class="indicator-progress">Please wait...
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                    </button>
                </div>
                <!--end::Form-->
            </div>

            <!--end::Modal body-->
        </div>
        <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
</div>
<ng-template #add_update_question>
    <div class="modal-dialog-centered" id="add-eval" tabindex="-1" aria-hidden="true">
        <!--begin::Modal dialog-->
        <!--begin::Modal content-->
        <div class="modal-content">
            <!--begin::Modal header-->
            <div class="modal-header">
                <!--begin::Modal title-->
                <h2 class="">{{mode=='create'?'Ajouter':'Modifier'}} évaluation</h2>
                <!--end::Modal title-->
                <!--begin::Close-->
                <div id="kt_customers_export_close" data-bs-dismiss="modal"
                    class="btn btn-icon btn-sm btn-active-icon-primary">
                    <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
            </div>
            <div class="modal-body">
                <!--begin::Form-->
                <form id="kt_customers_export_form" class="form tools" action="#" [formGroup]="questionForm">
                    <div class="mb-5">
                        <label for="question" class="required form-label">Question</label>
                        <input type="text" formControlName="question" class="form-control" placeholder="Question" (input)="checkQuestionChange()" />
                    </div>
                </form>
                <div class="text-end ">
                    <button (click)="closeModal()" type="reset" id="kt_customers_export_cancel" data-bs-dismiss="modal" class="footer-btn annuler me-3">Annuler</button>
                    <button [disabled]="!questionForm.valid || disableConfirmButton" (click)="submitData()" type="submit" id="kt_customers_export_submit" class="footer-btn confirmer">
                        <span class="indicator-label">Confirmer</span>
                        <span class="indicator-progress">Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                    </button>
                </div>
                <!--end::Form-->
            </div>

            <!--end::Modal body-->
        </div>
        <!--end::Modal content-->
        <!--end::Modal dialog-->
    </div>
</ng-template>